import { GridSortItem } from '@mui/x-data-grid';
import { KeyValuePair } from '@myme/utils';

export const transformSortingToSearchParams = (sorting: GridSortItem) => {
  const sortingParams: KeyValuePair[] = [{ key: 'sortDirection', value: sorting.sort!.toLocaleUpperCase() }];

  if (sorting.field) {
    sortingParams.push({ key: 'sortField', value: sorting.field });
  }

  return sortingParams;
};
